export default function ApiMarket({ title = "数据集市" }: { title?: string }) {
  return (
    <div className="flex-1 bg-white p-8">
      <h2 className="text-xl font-bold">{title}</h2>
    </div>
  );
}